<template>
    <div
        :class="{ 'form__field--error' : errorMessage }"
        class="form__field"
    >
        <label class="input__label">{{ $t(label) | capitalize }}</label>
        <input
            :class="{ 'input__field--error' : errorMessage }"
            class="input__field"
            :value="value"
            v-bind="$attrs"
            @input="onInput"
            @blur="onBlur"
            ref="input"
        />
        <div
            v-if="errorMessage"
            class="message message--error"
        >
            <i class="icon icon--xs icon-warning_triangle"/>
            <span>
                {{ errorMessage }}
            </span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BaseInput from './BaseInput';

    export default Vue.component('CustomInput', {
        mixins: [BaseInput],
        props: {
            label: {
                type: String,
                required: false,
                default: ''
            },
            errorMessage: {
                type: String,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                // field is needed because user can click on input without writing anything
                // but we want to show him an error if field is required
                isDirty: false,
            };
        },
        methods: {
            focusInput() {
                this.$refs.input.focus();
            },
        },
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/forms/CustomInput.vue